// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"0391a57d","590":"9e43f645"}[chunkId] + ".chunk.js";
};